var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-page-outer",class:{ 'over-wrap': _vm.type === 'normal' }},[_c('div',{staticClass:"curriculum-step-page"},[(_vm.type === 'circular')?_c('for-high-step',{ref:"circular"}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }